import React, {useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {MdDashboard, MdKeyboardArrowDown, MdKeyboardArrowUp} from "react-icons/md";
import {Can} from "../../Can";

const DashboardDropdownSidebar = ({thememode}) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleMainClick = () => {
        // Navigate to the default dashboard page
        navigate("/Dashboards");
    };

    const handleArrowClick = (e) => {
        e.stopPropagation(); // Prevent triggering the main click
        setIsOpen(!isOpen);
    };

    return (
        <div className="mb-1">
            <div
                className={`flex items-center justify-between p-3 pl-6 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300`}
                onClick={handleMainClick}
            >
                <div className={'flex items-center '}>
                    <MdDashboard className="mr-3"/>
                    <span className="flex-grow">Dashboard</span>
                </div>
                <div
                    className="p-1 hover:bg-gray-300 dark:hover:bg-gray-600 rounded"
                    onClick={handleArrowClick}
                >
                    {isOpen ? <MdKeyboardArrowUp/> : <MdKeyboardArrowDown/>}
                </div>
            </div>

            {isOpen && (
                <div>
                    <Can I="stats" a="dashboard">
                    <NavLink
                        to="/Dashboard"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Simple Dashboard</span>
                    </NavLink>
                    </Can>
                    <Can I={'stats'} a={'detaild_dashboard'}>
                        <NavLink
                            to="/DetailedDashboard"
                            className={({isActive}) =>
                                `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                    isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                                }`
                            }
                        >
                            <span>Detailed Dashboard</span>
                        </NavLink>
                    </Can>

                </div>
            )}
        </div>
    );
};

export default DashboardDropdownSidebar;